var React = require('react');

function Date (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Ellipse_2","data-name":"Ellipse 2","transform":"translate(0 0)","fill":"none","stroke":"#949494","strokeWidth":"1","key":0},[React.createElement("ellipse",{"cx":"6.494","cy":"6.495","rx":"6.494","ry":"6.495","stroke":"none","key":0}),React.createElement("ellipse",{"cx":"6.494","cy":"6.495","rx":"5.994","ry":"5.995","fill":"none","key":1})]),React.createElement("path",{"id":"Path_1006","data-name":"Path 1006","d":"M7562-19327.041v3.91l3.106,1.707","transform":"translate(-7555.505 19329.898)","fill":"none","stroke":"#949494","strokeLinecap":"round","strokeWidth":"1","key":1})]);
}

Date.defaultProps = {"id":"Group_901","data-name":"Group 901","width":"12.989","height":"12.989","viewBox":"0 0 12.989 12.989"};

module.exports = Date;

Date.default = Date;
